export default __webpack_public_path__ + "ui/assets/img/arrow-sort-asc-20.svg";